import { useSavedContractsContext } from "./savedContractsContext";

export function useSavedContractsStore() {
  return useSavedContractsContext();
}
